import { type MailRibbonGroupId, type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import GroupStrings from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import type { MenuDefinition, RibbonFlyoutAnchorProps } from 'owa-acui';
import NoteEdit from 'owa-fluent-icons-svg/lib/icons/NoteEditRegular';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { owaComputedFn } from 'owa-computed-fn';
import { constructKeytip } from 'owa-command-ribbon';
import { createMailAppFlyoutAnchor } from 'owa-mail-ribbon-utils/lib/createMailRibbonButton';
import loc from 'owa-localize';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';

const emptyMenuDefinition: MenuDefinition = {
    sections: [],
};

export const getMLRNotesTabCommonGroupFlyout: (
    groupId: RibbonGroupId,
    props: ReadOnlyRibbonControlDefProps
) => RibbonFlyoutAnchorProps | undefined = owaComputedFn(function getMLRNotesTabCommonGroupFlyout(
    groupId: RibbonGroupId,
    props: ReadOnlyRibbonControlDefProps
): RibbonFlyoutAnchorProps | undefined {
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
    switch (groupId) {
        case 145:
            return createMailAppFlyoutAnchor(
                groupId,
                loc(GroupStrings.notes_GroupEdit),
                undefined /*tooltip*/,
                props,
                emptyMenuDefinition,
                mailboxInfo,
                constructKeytip([6], 145),
                NoteEdit
            );

        default:
            return undefined;
    }
});
